import { css } from 'styled-components';
import { pitchTheme } from './theme';

/** Shared weight for page titles, section headings, and slide titles. */
export const headingFontWeight = 500;

/** Slide and page body text (bullets, descriptions, paragraphs). */
export const contentFont = css`
  font-family: ${pitchTheme.fontContent};
`;

/** Titles and display headings inside slides. */
export const headingFont = css`
  font-family: ${pitchTheme.fontHeading};
  font-weight: ${headingFontWeight};
`;

/** Top-level h1 titles on app pages and major section headings. */
export const pageTitleFont = css`
  font-family: ${pitchTheme.fontPageTitle};
  font-weight: ${headingFontWeight};
`;

/** Navigation, buttons, labels, and other UI chrome. */
export const uiFont = css`
  font-family: ${pitchTheme.fontUi};
`;
